import { type AccommodationDetail } from '@/api/accommodation/types'
import { unitFullName, unitPhotos } from '@/lib/unit'
import { type LocationDiscount } from '@/api/accommodation/hooks'
import { useIsMobile } from '@/hooks/useIsMobile'
import { BackLink } from '@/components/BackLink'
import { useRouterState } from '@tanstack/react-router'
import { ImageGalleryMobile } from './ImageGalleryMobile'
import { ImageGalleryDesktop } from './ImageGalleryDesktop'
import { DetailShareButton } from '../DetailShareButton'
import { WatchHeartButton } from '@/features/accommodation/watch-heart/WatchHeartButton'

interface DetailHeroSectionProps {
  data: AccommodationDetail
  discount?: LocationDiscount
}

export function DetailHeroSection({ data, discount }: DetailHeroSectionProps) {
  const isMobile = useIsMobile()
  const backHref = useRouterState({
    select: (s) => (s.location.state as { backHref?: string } | undefined)?.backHref,
  })

  return (
    <div className="mb-6 md:mb-0">
      <div className="container hidden items-start justify-between pt-6 pb-4 lg:flex">
        {backHref ? (
          <BackLink href={backHref}>Zpět na vyhledávání</BackLink>
        ) : (
          <BackLink to="/ubytovani/hledat">Zpět na vyhledávání</BackLink>
        )}
        <div className="flex items-center gap-5">
          <WatchHeartButton slug={data.slug} unitId={data.unit.id} source="detail" variant="link" />
          <DetailShareButton name={unitFullName(data, data.unit)} />
        </div>
      </div>
      <div className="container">
        {isMobile ? (
          <ImageGalleryMobile
            images={unitPhotos(data.unit, data)}
            typeName={data.unit.type.name}
            discount={discount}
            unitId={data.unit.id}
          />
        ) : (
          <ImageGalleryDesktop
            images={unitPhotos(data.unit, data)}
            locationSlug={data.slug}
            unitSlug={data.unit.slug}
            typeName={data.unit.type.name}
            discount={discount}
          />
        )}
      </div>
    </div>
  )
}
